import { defineCustomElement } from 'vue'
import router from './infrastructure/router.ts';
import i18n from './infrastructure/i18n.ts';
import App from './App.vue'
import allStyles from './styles.all.css?inline'
import sakStyles from './styles.sak.css?inline'

const GfoCheckout = defineCustomElement(App, {
  configureApp(app) {
    app.use(router)
    app.use(i18n)
  },
  styles: [allStyles, sakStyles],
})

customElements.define('gfo-checkout', GfoCheckout)
